// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1fDAi","label":"LabeledBox_label__3F0mX"};